import {
  Container,
  Typography,
  Grid,
  Paper,
  Rating,
} from '@mui/material'

const testimonials = [
  {
    name: 'Rajesh Sharma',
    rating: 5,
    comment: 'Perfect location near Jagannath Temple. The staff was extremely courteous and the rooms were immaculately clean. Will definitely visit again.',
    position: 'Family Traveller, Delhi'
  },
  {
    name: 'Priya Patel',
    rating: 5,
    comment: 'Excellent hospitality with true Odia warmth. The morning breakfast was delicious and the hotel arranged our temple visits perfectly.',
    position: 'Corporate Professional, Mumbai'
  },
  {
    name: 'Arun Krishnan',
    rating: 5,
    comment: 'A wonderful stay during our pilgrimage. The hotel staff helped us with all temple schedules and prasad arrangements. Highly recommended.',
    position: 'Retired Professor, Bangalore'
  }
]

const Testimonials = () => {
  return (
    <Container maxWidth="xl" sx={{ 
      pt: { xs: 4, md: 6 },
      pb: { xs: 4, md: 6 },
      bgcolor: 'background.default',
    }}>
      <Typography
        variant="h2"
        align="center"
        sx={{
          mb: { xs: 4, md: 5 },
          fontFamily: '"Playfair Display", serif',
          '& span': { color: 'primary.main' }
        }}
      >
        Guest <span>Testimonials</span>
      </Typography>
      <Grid container spacing={4}>
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              elevation={2}
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                borderRadius: 2,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                },
              }}
            >
              <Rating 
                value={testimonial.rating} 
                readOnly 
                sx={{ 
                  mb: 2,
                  '& .MuiRating-iconFilled': {
                    color: 'primary.main',
                  }
                }} 
              />
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontStyle: 'italic',
                  color: 'text.secondary',
                  lineHeight: 1.8,
                }}
              >
                "{testimonial.comment}"
              </Typography>
              <Typography 
                variant="h6" 
                gutterBottom
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                }}
              >
                {testimonial.name}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{
                  fontWeight: 500,
                }}
              >
                {testimonial.position}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default Testimonials 